import React from "react";
import PropTypes from 'prop-types';
import { dateHelpers } from '../../../../../helpers';
import Loader from './../../../../common/elements/Loader';
import Anchor from "../../../../dashboardNew/objects/Anchor";
import {siteOfOriginHelper} from "../../../../../helpers/genericHelpers";

export const JobItem = props => {
    const siteOfOrigin = siteOfOriginHelper();
    if( !props.industries || !props.job.country ){ return <Loader/> };


    const salary = props.job.salary && ( props.job.salary.length > 35 || props.job.salary === "N/A" ? null : props.job.salary );
    const appliedDate = props.job.applied !== null ? dateHelpers.dateConverter( props.job.applied ) : null;
    const industryName = props.industries.find( industry => industry.id === props.job.industry.id );
    const locationName = props.locations.find( location => location.id === props.job.country.id );
    let colorClass = props.job.exclusive ? " exclusive" : props.job.premium_type === 1 ? " premium" : " standard" ;

    
    const title = () => {
        if( props.job.premium_type === 1 || props.job.exclusive ){
            return (
                <div className={`job-type ${ colorClass }`}>
                    <span className="job-type-title">
                        { props.job.premium_type === 1 ? "Premium/" : null }
                        { props.job.exclusive  ? "Exclusive" : null }
                    </span>
                </div>
            );
        };
    };

    const location = () => {
        if( !locationName ){ return };
        return (
            <li className="jobs-detail-item">
                <span className="item-head">Location:</span> { (props.locations.find( location => location.id === props.job.country.id ) || {}).name }
            </li>
        );
    };

    const industry = () => {
        if( !industryName ){ return };
        return (
            <div className="industry-body">
                <span className="industry-title">Industry</span>
                <span className="industry-item">{industryName.name}</span>
            </div>
        );
    };

    const date = () => {
        if( !appliedDate ){ return };
        return (
            <li className="jobs-detail-item">
                <span className="item-head">Applied:</span> {appliedDate}
            </li>
        );
    };

    const favourite = () => {
        if( props.job.favourite ){
            return (
                <button className="theme-favourite added" onClick={ () => props.removeJobFromFavourites( props.job.id, props.index ) }>
                    {siteOfOrigin !== 'us' ? 'Remove from Favourites' : 'Remove from Favorites'}
                    <i className="fa fa-heart fav-icon"/>
                </button>
            );
        };
        return (
            <button className="theme-favourite" onClick={ () => props.addJobToFavourites( props.job.id, props.index ) }>
                {siteOfOrigin !== 'us' ? 'Add to Favourites' : 'Add to Favorites'}
                <i className="fa fa-heart fav-icon"/>
            </button>
        );
    };

    const logo = () => {
        if( props.job.company_logo ){ return <img src={ props.job.company_logo } alt="company logo" className="image-logo"/> };
        return <img src="/images/job-placeholder.jpg" alt="job logo placeholder" className="image-logo default"/>;
    };


    return (
        <div key={ props.index } className="col-12  jobs-card">
            <div className="inner-card">
                { title() }
                <div className="col-12 col-lg-9 jobs-info">
                    <div className="col-12 heading">
                        <h3 className={`heading-three ${ props.job.viewed ? "viewed" : "" }`} dangerouslySetInnerHTML={{ __html : props.job.title }}/>
                    </div>
                    <ul className="jobs-detail-list">
                        <li className="jobs-detail-item">
                            <span className="item-head">Job:</span> #{ props.job.id }
                        </li>
                        <li className="jobs-detail-item">
                            <span className="item-head">Closing date:</span> { dateHelpers.dateConverter( props.job.end_date ) }
                        </li>
                        <li className="jobs-detail-item">
                            <span className="item-head">Salary:</span> <span dangerouslySetInnerHTML={{ __html : salary }}/>
                        </li>
                        { location() }
                        { date() }
                    </ul>
                    { industry() }
                </div>
                <div className="col-12 col-lg-3 jobs-side-info">
                    <div className="info-image">
                        { logo() }
                    </div>
                    <div className="info-button">
                        <Anchor path={`/jobs/${ props.job.id }`} anchorClass={`theme-button ${ props.job.viewed ? "secondary" : "" }`} internal>
                            { props.job.viewed ? "View Again" : "View Job" }
                        </Anchor>
                    </div>
                    <div className="info-save">
                        { favourite() }
                    </div>
                </div>
            </div>
        </div>
    );
};

JobItem.propTypes = {
	job                     : PropTypes.object,
	removeJobFromFavourites : PropTypes.func,
	addJobToFavourites      : PropTypes.func,
	locations               : PropTypes.array,
	industries              : PropTypes.array,
};



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/JobItem.js